/* eslint-disable */
import {combineReducers} from 'redux';
import admin from './admin';
import entreprise from './entreprise/_index';
import salarie from './salarie';
import shared from './shared';
import params from './params/_index'
import entretien from './entretien/_index';

export default combineReducers({
    shared,
    //admin,
    entreprise,
    params,
    entretien,
    salarie
})


// WEBPACK FOOTER //
// ./src/reducers/index.js